/* eslint-disable no-undef */
import {
    API,
    CALENDAR_GET_EVENTS_URL,
    CALENDAR_ADD_EVENT_URL,
    CALENDAR_UPDATE_EVENT_URL,
    CALENDAR_SEARCH_EVENTS_URL
} from "../variable";

import axios from 'axios'
import {
    CALENDAR_GET_EVENTS,
    CALENDAR_ADD_EVENT,
    CALENDAR_UPDATE_EVENT,
    CALENDAR_SEARCH_EVENTS
} from "../Actions/calendar.js";

const state = {

};

const actions = {
    [CALENDAR_GET_EVENTS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + CALENDAR_GET_EVENTS_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken },
        });
    },
    [CALENDAR_ADD_EVENT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + CALENDAR_ADD_EVENT_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken },
        });
    },
    [CALENDAR_UPDATE_EVENT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + CALENDAR_UPDATE_EVENT_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken },
        });
    },
    [CALENDAR_SEARCH_EVENTS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + CALENDAR_SEARCH_EVENTS_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken },
        });
    },
};

const mutations = {};

const getters = {};

export default {
    state,
    getters,
    actions,
    mutations
};